import React from 'react';
import classnames from 'classnames';

import styles from './line.module.scss';

interface Props {
  spacer?: 'small' | 'medium' | 'large' | 'xlarge';
}

const Line = ({ spacer = 'small' }: Props) => (
  <hr className={classnames(styles.line, spacer && styles[spacer])} />
);

export default Line;
